import BlitDiagram from "../../../../docs/_images/blit.png";
import BlitStrideDiagram from "../../../../docs/_images/blit-stride.png";
import * as React from 'react';
export default {
  BlitDiagram,
  BlitStrideDiagram,
  React
};